import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=013f95ef&scoped=true&"
import script from "./CButton.vue?vue&type=script&lang=js&"
export * from "./CButton.vue?vue&type=script&lang=js&"
import style0 from "./CButton.vue?vue&type=style&index=0&id=013f95ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f95ef",
  null
  
)

export default component.exports